


































































































import { Vue, Component } from "vue-property-decorator";
import { BTab, BTabs, BCard } from "bootstrap-vue";
import { app } from "../firebaseConfig";
import { user, Pothole, geoPos } from "@/datatypes";
import axios, { AxiosResponse } from "axios";
import {
  getAuth,
  Auth,
  signOut,
  deleteUser,
  sendPasswordResetEmail,
} from "firebase/auth";
import {
  collection,
  CollectionReference,
  doc,
  DocumentReference,
  Firestore,
  DocumentSnapshot,
  getDoc,
  getFirestore,
  setDoc,
  deleteDoc,
  onSnapshot,
} from "firebase/firestore";

//Constants
const db: Firestore = getFirestore(app);
const userInfoColl: CollectionReference = collection(db, "users");
const potholeCollection: CollectionReference = collection(db, "potholes");
const allReportsDoc: DocumentReference = doc(potholeCollection, "allReports");

@Component({ components: { BTab, BTabs } })
export default class AccountView extends Vue {
  testVar = "This is from the testVar";
  uid: string | undefined = "";
  userDoc!: DocumentReference;
  auth: Auth | null = null;
  userInfoObj: user = {
    fname: "",
    lname: "",
    dotEmployee: false,
    dotID: "",
    email: "",
    phone: "",
    zipcode: "",
    lat: "42.93066",
    long: "-85.655173",
    locality: "",
  };
  userReportArr: Array<Pothole> = [];
  message = "";
  userInfoLoaded = false;

  mounted() {
    this.auth = getAuth();
    this.uid = this.auth?.currentUser?.uid;
    this.userDoc = doc(userInfoColl, this.uid);

    this.getUserInfo();
    this.getPotholes();
  }

  //This function listens for updates
  getPotholes(): void {
    onSnapshot(allReportsDoc, (reports: DocumentSnapshot) => {
      if (reports.exists()) {
        for (let report of reports.data().potholeArray) {
          if (report.creatorUID === this.uid) {
            this.userReportArr.push(report);
          }
        }
        console.log("Pothole Array has been updated");
      }
    });
  }

  getUserInfo() {
    getDoc(this.userDoc).then((userData: DocumentSnapshot) => {
      if (userData.exists()) {
        this.userInfoObj = userData.data().userInfo;
      }
    });
    this.userInfoLoaded = true;
  }

  //Function that gets the user's lat, long, and locality from their zipcode
  async getUserGeopos() {
    await axios
      .request({
        method: "GET",
        url: "https://api.allorigins.win/get",
        params: {
          url: `http://api.positionstack.com/v1/forward?access_key=a5af50b77b97143132298810bdd80333&query=${this.userInfoObj.zipcode}`,
        },
      })
      .then((r: AxiosResponse) => {
        return r.data;
      })
      .then((r: any) => JSON.parse(r.contents))
      .then((r: geoPos) => {
        this.userInfoObj.lat = r.data[0].latitude.toString();
        this.userInfoObj.long = r.data[0].longitude.toString();
        this.userInfoObj.locality = r.data[0].locality;
      });
  }

  /*
.then((r: AxiosResponse) => {
        return r.data;
      })
      .then((r: any) => JSON.parse(r.contents))
  */

  //This function stores the user object in firestore
  async storeUserInfo() {
    await this.getUserGeopos().then(() => {
      setDoc(this.userDoc, { userInfo: this.userInfoObj })
        .then(() => {
          this.showMessage(`Your profile has been updated.`);
        })
        .catch((err: any) => {
          console.log(`addDoc Error: ${err}`);
        });
    });
  }

  resetPassword() {
    console.log("Sening password reset");
    sendPasswordResetEmail(this.auth!, this.userInfoObj.email)
      .then(() => {
        this.showMessage(
          `A password reset link has been sent to ${this.userInfoObj.email}`
        );
      })
      .catch((err: any) => {
        this.showMessage("Unable to reset password ${err}");
      });
  }

  //Function to sign user out
  signOut(): void {
    if (this.auth) signOut(this.auth);

    // Back to login page
    this.$router.push({ name: "login" });
  }

  //Function to delete a user account and their data
  deleteAcct(): void {
    var dltUser = this.auth!.currentUser;
    if (dltUser) {
      deleteDoc(this.userDoc);
      deleteUser(dltUser);
      // Back to login page
      this.$router.push({ name: "login" });
    }
  }

  showMessage(txt: string) {
    this.message = txt;

    // The message will automatically disappear after 5 seconds
    setTimeout(() => {
      this.message = "";
    }, 5000);
  }
}
